export default __webpack_public_path__ + "static/media/Arrow.ba81676c.svg";